import * as React from "react";

import { makeStyles } from "@fluentui/react-components";

import { MailboxProvider } from "@features/mailbox";
import { LoginForm, useAuth } from "@features/auth";
import { AttachmentUploader } from "@features/document";

import { LayoutProvider } from "@shared/ui/LayoutContext";

import AppHeader from "./AppHeader";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  centered: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    flex: 1,
  },
});

const App: React.FC = () => {
  const styles = useStyles();
  const { profile } = useAuth();

  const rootRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className={styles.root} ref={rootRef}>
      <LayoutProvider targetRef={rootRef}>
        {!profile ? (
          <div className={styles.centered}>
            <LoginForm />
          </div>
        ) : (
          <MailboxProvider>
            <AppHeader />
            <div className={styles.content}>
              <AttachmentUploader />
            </div>
          </MailboxProvider>
        )}
      </LayoutProvider>
    </div>
  );
};

export default App;
